<template>
    <vue-modal-custom
        v-model="modal.visible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :keyboard="false"
        :modalBodyClass="$prefixClass.modal + `-publish-theme-success`"
    >
        <h4 class="m-b-28">{{$t('optimize_image.components.publish_success_title')}}</h4>
        <a-button class="m-b-12" type="secondary" @click="goodAction">{{$t('optimize_image.buttons.yes_look_good')}}</a-button>
        <a-button type="primary" @click="badAction">{{$t('optimize_image.buttons.no_broken')}}</a-button>
    </vue-modal-custom>
</template>
<script>

export default {
    name: 'ModalPublishThemeSuccess',
    props: {
        value: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        goodAction() {
            this.modal.visible = false
        },
        badAction() {
            this.modal.visible = false
            this.$emit('bad-publish')
        }
    }
}
</script>
<style lang="scss">
    .#{$modal}-publish-theme-success {
        width: 400px !important;
        .#{$modal} {
            &-content {
                border-radius: 12px;
            }
            &-body {
                padding: 32px 24px;
                text-align: center;
                .#{$btn} {
                    width: 210px;
                    border-radius: 32px;
                    height: 40px;
                    &-secondary {
                        border-color: $primary-color;
                        &:hover {
                            border-color: $text-color;
                        }
                    }
                }
            }
        }
    }
</style>
